import React from "react";
import { Dimmer, Loader, Segment } from "semantic-ui-react";

type CardPreviewPostType = {
  id: string;
  version: number;
  publishJson: any;
};

const CardPreviewPost = (props: CardPreviewPostType) => {
  return (
    <>
      {props.publishJson ? (
        <div className="sun-editor-editable">
           <div dangerouslySetInnerHTML={{__html: props.publishJson?.content}} />
            </div>
      ) : (
        <Segment style={{ height: "100px" }}>
          <Dimmer active inverted>
            <Loader />
          </Dimmer>
        </Segment>
      )}
    </>
  );
};

export default CardPreviewPost;
